// 海外采购

export default{
path:'/',
name: 'buyer',
redirect: '/buyer/list',
component: () => import('@/views/overseas-buyer/index.vue'),
  meta: {
    title: '智工嗨搜',
    newTab: true,
    keepAlive: true,
    disableScroll: false,
    broadcast: true,
    icon: 'icon-zhinengyingxiao'
  },
  children: [
    {
      path: '/buyer/list',
      name: 'list',
      component: () => import('@/views/overseas-buyer/list.vue'),
      meta: {
        title: '海外采购检索',
        noBg:true
      }
    },
    {
      path: '/intellect-marketing/mail-list',
      name: 'mail-list',
      component: () => import('@/views/intellect-marketing/mail/list.vue'),
      meta: {
        title: '营销邮件',
        noBg:true,
        // keepAlive: true
      }
    },
    {
      path: '/intellect-marketing/statistics',
      name: 'statistics',
      component: () => import('@/views/intellect-marketing/mail/statistics.vue'),
      meta: {
        title: '发送统计',
        noBg:true,
      }
    },
    // 创建邮件
    {
      path: '/intellect-marketing/created-mail',
      name: 'created-mail',
      component: () => import('@/views/intellect-marketing/mail/created-mail.vue'),
      meta:{
        unMenu:true,
        activeMenu:'mail-list',
      }
    },
    //客户管理的邮件
    {
      path: '/intellect-marketing/customer-mail',
      name: 'customer-mail',
      component: () => import('@/views/customer-management/sendEmailcode.vue'),
      meta:{
        unMenu:true,
        activeMenu:'mail-list',
      }
    },
    // 查看营销任务详情
    {
      path: '/intellect-marketing/mail-detail',
      name: 'mail-detail',
      component: () => import('@/views/intellect-marketing/mail/mail-detail.vue'),
      meta:{
        unMenu:true,
        activeMenu:'mail-list',
      }
    },
  ]
}

